export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册信息"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存数据"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已确认"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此字段为公开字段，其他用户可以看到"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此字段对其他用户隐藏"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已验证"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["进行中"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未验证"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开始验证"])}
}